exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".support-ico[data-v-53e2c7fd]{display:inline-block;background-repeat:no-repeat}.icon-1[data-v-53e2c7fd]{width:.6rem;height:.6rem;background-size:.6rem .6rem}.icon-2[data-v-53e2c7fd]{width:.8rem;height:.8rem;background-size:.8rem .8rem}.icon-3[data-v-53e2c7fd]{width:.6rem;height:.6rem;background-size:.6rem .6rem}.icon-4[data-v-53e2c7fd]{width:.8rem;height:.8rem;background-size:.8rem .8rem}", ""]);

// exports
